// API client for constructor control operations
function getDeleteWaitingResultConstraints(controlIds, chassisIds, httpClient) {
  return httpClient({
    url: '/constructors/control/delete-waiting-constraints',
    method: 'POST',
    data: JSON.stringify({
      controlIds: controlIds || [],
      chassisIds: chassisIds || [],
    }),
  }).then((res) => res.data)
}

function deleteWaitingResult(controlIds, chassisIds, httpClient) {
  return httpClient({
    url: '/constructors/control/waiting',
    method: 'DELETE',
    data: JSON.stringify({
      controlIds: controlIds || [],
      chassisIds: chassisIds || [],
    }),
  })
}

function emailResult(controlId, emails, sendTo, httpClient) {
  return httpClient({
    url: `/constructors/control/${controlId}/email-result`,
    method: 'POST',
    data: JSON.stringify({ emails, sendTo }),
  })
}

function emailResultByList(controlId, emailLists, httpClient) {
  return httpClient({
    url: `/constructors/control/${controlId}/email-result-by-list`,
    method: 'POST',
    data: JSON.stringify({ emailLists }),
  })
}

export default {
  getDeleteWaitingResultConstraints,
  deleteWaitingResult,
  emailResult,
  emailResultByList,
}
